import { configureStore } from "@reduxjs/toolkit";
import coinsReducer from "./features/coins/slice";
import userReducer from "./features/user/slice";
import themeReducer from "./features/theme/slice";
import planReducer from "./features/plan/slice";
import portfolioReducer from "./features/portfolio/slice";

export const store = configureStore({
    reducer: {
        coinsReducer,
        userReducer,
        themeReducer,
        planReducer,
        portfolioReducer
    },
});